// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 33"
    {...props}
  >
    <path
      fill="#fff"
      d="M15.9974 18.6263C18.9429 18.6263 21.3307 16.2385 21.3307 13.293C21.3307 10.3475 18.9429 7.95964 15.9974 7.95964C13.0519 7.95964 10.6641 10.3475 10.6641 13.293C10.6641 16.2385 13.0519 18.6263 15.9974 18.6263Z"
    />
    <path
      fill="#fff"
      d="M15.9974 29.9596C23.3612 29.9596 29.3307 23.9901 29.3307 16.6263C29.3307 9.26251 23.3612 3.29297 15.9974 3.29297C8.6336 3.29297 2.66406 9.26251 2.66406 16.6263C2.66406 23.9901 8.6336 29.9596 15.9974 29.9596Z"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M7.08579 26.5442C7.89689 24.6332 9.79063 23.293 11.9974 23.293H19.9974C22.2042 23.293 24.0979 24.6332 24.909 26.5442M21.3307 13.293C21.3307 16.2385 18.9429 18.6263 15.9974 18.6263C13.0519 18.6263 10.6641 16.2385 10.6641 13.293C10.6641 10.3475 13.0519 7.95964 15.9974 7.95964C18.9429 7.95964 21.3307 10.3475 21.3307 13.293ZM29.3307 16.6263C29.3307 23.9901 23.3612 29.9596 15.9974 29.9596C8.6336 29.9596 2.66406 23.9901 2.66406 16.6263C2.66406 9.26251 8.6336 3.29297 15.9974 3.29297C23.3612 3.29297 29.3307 9.26251 29.3307 16.6263Z"
    />
  </svg>
);
const IconUser = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUser;
